import React, { useEffect } from "react";
import AppleLogin from "react-apple-login";
import { useLocation, useNavigate } from "react-router-dom";
import appleImg from "../../../images/apple.png";

const WebAppleLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
  const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI;

  const handleAppleResponse = (response) => {
    if (response && response.authorization) {
      const { code, id_token } = response.authorization;
      try {
        const appleUser = response.user || {};
        const firstName = appleUser?.name?.firstName || "";
        const lastName = appleUser?.name?.lastName || "";
        sessionStorage.setItem(
          "appleSignInUser",
          JSON.stringify({
            email: appleUser.email || "",
            fullName: `${firstName} ${lastName}`.trim(),
          }),
        );
      } catch (storageError) {
        console.error("Could not stash Apple user details:", storageError);
      }

      window.location.href = `/callback?code=${encodeURIComponent(code)}&id_token=${encodeURIComponent(id_token)}`;
    } else {
      console.error("Missing authorization data in the response.");
    }
  };

  const handleAppleError = (error) => {
    console.error("Apple login error:", error);
  };

  const appleResponse = (response) => {
    if (!response.error) {
    } else {
      console.error("Apple Sign-In Error:", response.error);
    }
  };

  return (
    <div className="w-full">
      <AppleLogin
        clientId={APPLE_CLIENT_ID}
        redirectURI={APPLE_REDIRECT_URI}
        responseType="code id_token"
        responseMode="query"
        usePopup={true}
        callback={handleAppleResponse}
        scope="email name"
        onError={handleAppleError}
        render={(props) => (
          <button
            onClick={props.onClick}
            className="mt-1 secondary-button text-black items-center px-4 h-11 border border-gray-300 justify-center flex w-full rounded-[16px]"
          >
            {
              <img
                src={appleImg}
                className=" w-7 inline-block mx-1"
                alt="Google-logo"
              />
            }
            Continue with Apple
          </button>
        )}
      />
    </div>
  );
};

export default WebAppleLogin;
